import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import type { NotificationId, NotificationMutator } from '@beaded/models'

import * as apiUtils from '.'

const url = '/notification'

export const get = (id: NotificationId, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/${id}`, merge({}, options))

export const getAll = (options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/`, merge({}, options))

export const update = (id: NotificationId, data: NotificationMutator) =>
  apiUtils.PUT(`${url}/${id}`, data)

export const remove = (id: NotificationId) => apiUtils.DELETE(`${url}/${id}`)
